import React, { ReactElement } from 'react';

import './insightsPage.sass';

const InsightsPage = (): ReactElement => <div>InsightsPage</div>;

export default InsightsPage;
